import useStudentSubjects from "../../hooks/useStudentSubjects"

/** Loads learner subjects for the practice-paper generator. */
const usePaperGenerator = () => useStudentSubjects()

export default usePaperGenerator
